import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';

const Data = [
    {  
        id: 1,
        light_icon: "/images/growth/rating.png",
        dark_icon: "/images/icon/icon-10.png",
        countNum: 99,
        plus_icon: false,
        need_space: false,
        unit: '%',
        text: "Average Client Rating",
        sub_text: "Out of total 350+ reviews"
    },
    {  
        id: 2,
        // light_icon: "/images/icon/icon-8.png",
        light_icon: "/images/growth/team.png",
        dark_icon: "/images/icon/icon-11.png",
        countNum: 5,
        need_space: false,
        plus_icon: false,
        text: "Specialists",
        sub_text: "Across all Domains"
    },
    {  
        id: 3,
        light_icon: "/images/growth/years.png",
        dark_icon: "/images/icon/icon-12.png",
        countNum: 30,
        need_space: true,
        unit: 'years',
        plus_icon: true,
        text: "team experience",
        sub_text: "combined knowledge"
    },
    {  
        id: 4,
        light_icon: "/images/growth/business.png",
        dark_icon: "/images/icon/apple-black.png",
        countNum: 12,
        need_space: false,
        plus_icon: true,
        text: "business appreciations",
        sub_text: "Service Excellence"
    }
   
];

const renderSpace = data => {
    if (data.need_space) {
        return (<>&nbsp;</>)
    }
}

const CounterUp = ({colSize, layoutStyle, evenTopMargin}) => {

    return (
        <>
            {Data.map((data) => (
                <div className={`${colSize} ${(data.id % 2  === 0) ? evenTopMargin : ""}`} key={data.id} >
                    <div className={`counterup-progress ${layoutStyle}`}>

                        { 
                            layoutStyle === "counterup-style-2" ? 
                            <div className="icon">
                                <img className="dark-icon" src={process.env.PUBLIC_URL + data.dark_icon} alt="Icon" />
                                <img className="light-icon" src={process.env.PUBLIC_URL + data.light_icon} alt="Icon" />
                            </div> : 
                            <div className="icon">
                                <img src={process.env.PUBLIC_URL + data.light_icon} alt="Icon" />
                            </div> 
                        }

                        <div className="count-number h2">
                            <TrackVisibility once>
                                {({isVisible}) => (
                                    <span className="number count">
                                        {isVisible ? <CountUp end={data.countNum} duration={2} /> : null}
                                    </span>
                                )}  
                            </TrackVisibility>
                            {
                                data.unit ? <span className="symbol">{renderSpace(data)}{data.unit}</span> : <span className="symbol">+</span>
                            }
                        </div>
                        <h6 className="title">{data.text}</h6>
                        <p className="crazy-sub-title">{data.sub_text}</p>
                    </div>
                </div>
            ))}
        </>
    )
}



export default CounterUp;